import { Globe, Settings } from "lucide-react";

const DiscordIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.32 4.37a19.8 19.8 0 0 0-4.89-1.52.07.07 0 0 0-.08.04c-.21.38-.44.87-.61 1.25a18.27 18.27 0 0 0-5.49 0 12.6 12.6 0 0 0-.62-1.25.08.08 0 0 0-.08-.04 19.74 19.74 0 0 0-4.89 1.52.07.07 0 0 0-.03.03C.53 9.05-.32 13.58.1 18.06a.08.08 0 0 0 .03.06 19.9 19.9 0 0 0 5.99 3.03.08.08 0 0 0 .08-.03c.46-.63.87-1.3 1.23-1.99a.08.08 0 0 0-.04-.11 13.1 13.1 0 0 1-1.87-.89.08.08 0 0 1-.01-.13l.37-.29a.07.07 0 0 1 .08-.01c3.93 1.79 8.18 1.79 12.07 0a.07.07 0 0 1 .08.01l.37.29a.08.08 0 0 1-.01.13c-.6.35-1.22.65-1.87.89a.08.08 0 0 0-.04.11c.36.7.77 1.36 1.23 1.99a.08.08 0 0 0 .08.03 19.83 19.83 0 0 0 6-3.03.08.08 0 0 0 .03-.06c.5-5.18-.84-9.67-3.55-13.66a.06.06 0 0 0-.03-.03ZM8.02 15.33c-1.18 0-2.16-1.09-2.16-2.42s.96-2.42 2.16-2.42c1.21 0 2.18 1.1 2.16 2.42 0 1.33-.96 2.42-2.16 2.42Zm7.97 0c-1.18 0-2.16-1.09-2.16-2.42s.96-2.42 2.16-2.42c1.21 0 2.18 1.1 2.16 2.42 0 1.33-.95 2.42-2.16 2.42Z" />
  </svg>
);

const Tile = ({ onClick, label, testid, accent, children }) => (
  <button onClick={onClick} data-testid={testid} title={label}
    className={`group flex-1 flex flex-col items-center justify-center gap-1.5 py-3 rounded-lg border border-white/10 bg-black/50 backdrop-blur-md transition-[border-color,transform,background-color] hover:-translate-y-0.5 ${accent}`}>
    {children}
    <span className="text-[10px] uppercase tracking-[0.2em] text-slate-400 group-hover:text-slate-200 transition-colors">{label}</span>
  </button>
);

export default function QuickLinks({ settings, openLink, openConfig }) {
  return (
    <div className="flex gap-2" data-testid="launcher-quick-links">
      {settings.website_url && (
        <Tile onClick={() => openLink(settings.website_url)} label="Strona" testid="launcher-website-link" accent="hover:border-amber-400/60 text-amber-300">
          <Globe size={22} />
        </Tile>
      )}
      {settings.discord_url && (
        <Tile onClick={() => openLink(settings.discord_url)} label="Discord" testid="launcher-discord-link" accent="hover:border-[#5865F2] hover:bg-[#5865F2]/15 text-[#8b95ff]">
          <DiscordIcon />
        </Tile>
      )}
      <Tile onClick={openConfig} label="Opcje" testid="launcher-config-btn" accent="hover:border-amber-400/60 text-amber-300">
        <Settings size={22} className="group-hover:rotate-90 transition-transform duration-500" />
      </Tile>
    </div>
  );
}
